export const frontEndUrl = 'https://herbarium.ssau.ru'
export const backEndUrl = 'https://herbarium.ssau.ru/api'
export const labelCompressedPhotoPath = backEndUrl + '/exhibit/original-label/compressed-photo'
export const labelOriginPhotoPath = backEndUrl + '/exhibit/original-label/origin-photo'
export const exhibitCompressedPhotoPath = backEndUrl + '/exhibit/compressed-photo'
export const exhibitOriginPhotoPath = backEndUrl + '/exhibit/origin-photo'
export const photoOfSpeciesCompressedPath = backEndUrl + '/photo-of-species-in-nature/compressed-photo'
export const photoOfSpeciesOriginPath = backEndUrl + '/photo-of-species-in-nature/origin-photo'
